import { format } from "date-fns";
import Spinner from "../../components/spinner";
import styles from "../../styles/_containers/_appointmentRequests/requestCard.module.scss";

const formatDate = (date) => {
  if (!date) return null;
  try {
    return format(new Date(date), "dd/MM/yyyy");
  } catch {
    return null;
  }
};

const formatTime = (date) => {
  if (!date) return null;
  try {
    return format(new Date(date), "HH:mm");
  } catch {
    return null;
  }
};

const RequestCard = ({ request, onRespond, respondingId }) => {
  const customerName = request.customerName || request.customer?.name || "-";
  const customerPhone = request.customerPhone || request.customer?.phone || "";
  const serviceName = request.serviceName || request.service?.name || "";
  const employeeName = request.employeeName || request.employee?.name || "";
  const requestedDate = request.date || request.requestedDate || request.startDate;
  const comment = request.comment || request.note || "";
  const amount = request.price ?? request.amount ?? null;
  const subServices = request.subServices || [];
  const isLoading = respondingId === request._id;

  const dateStr = formatDate(requestedDate);
  const timeStr = formatTime(requestedDate);

  return (
    <div className={styles.card}>
      {/* Customer */}
      <div className={styles.customerRow}>
        <span className={styles.customerName}>{customerName}</span>
        {customerPhone && (
          <span className={styles.customerPhone}>{customerPhone}</span>
        )}
      </div>

      {/* Service */}
      {serviceName && (
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>שירות:</span>
          <span>{serviceName}</span>
        </div>
      )}

      {/* Date & Time */}
      {dateStr && (
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>תאריך מבוקש:</span>
          <span>
            {dateStr}
            {timeStr && ` בשעה ${timeStr}`}
          </span>
        </div>
      )}

      {/* Employee */}
      {employeeName && (
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>נותן שירות:</span>
          <span>{employeeName}</span>
        </div>
      )}

      {/* Sub-services */}
      {subServices.length > 0 && (
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>שירותים נוספים:</span>
          <span className={styles.subServices}>
            {subServices.map((s) => s.name || s).join(", ")}
          </span>
        </div>
      )}

      {/* Price */}
      {amount != null && (
        <div className={styles.price}>
          {"\u20AA"}{amount}
        </div>
      )}

      {/* Comment */}
      {comment && (
        <div className={styles.commentBox}>
          <div className={styles.commentLabel}>הערת לקוח</div>
          {comment}
        </div>
      )}

      {/* Actions */}
      <div className={styles.actions}>
        <button
          className={styles.approveBtn}
          onClick={() => onRespond(request._id, 1)}
          disabled={isLoading}
        >
          {isLoading && respondingId === request._id ? <Spinner /> : "אשר"}
        </button>
        <button
          className={styles.declineBtn}
          onClick={() => onRespond(request._id, 2)}
          disabled={isLoading}
        >
          {isLoading && respondingId === request._id ? <Spinner /> : "דחה"}
        </button>
      </div>
    </div>
  );
};

export default RequestCard;
